module.exports = __webpack_public_path__ + "static/img/s11.8e9bcb24.png";